document.addEventListener('Searchanise.Loaded', function() {
  (function($) {

    $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
      BT.runCartAction('open_cart', function() {});
    });
  })(window.Searchanise.$);
});

(function() {
  var snizeRoot = null;
  var mo = null;
  var debounce = null;

  function isCollectionListing() {
    return !!document.querySelector('.template-collection');
  }

  function reorg() {
    if (!isCollectionListing()) { return; }
    var snize = document.getElementById('snize_results');
    if (!snize) { return; }
    snizeRoot = snize;

    if (mo) { mo.disconnect(); }

    var themeTitle = document.querySelector('.breadcrumbs-page-title:not(.subcollections-detected)');
    var wrapper = snize.querySelector('.snize-horizontal-wrapper');
    var sidebar = snize.querySelector('.snize-filters-sidebar');
    var name = themeTitle ? (themeTitle.textContent || '').trim() : '';

    if (snize.querySelector('.snize-search-results-main-content')) {
      document.documentElement.classList.toggle('ph-title-inline', !wrapper);
    }

    var srcCount = snize.querySelector('.snize-horizontal-left .snize-main-panel-collection-results-found')
                || snize.querySelector('.snize-horizontal-left .snize-search-results-header');
    if (sidebar && srcCount) {
      var num = ((srcCount.textContent || '').match(/\d[\d,]*/) || [''])[0];
      if (num) {
        var rc = sidebar.querySelector('.ph-results-count');
        if (!rc) {
          rc = document.createElement('div');
          rc.className = 'ph-results-count';
          sidebar.insertBefore(rc, sidebar.firstChild);
        }
        rc.textContent = name ? ('Showing ' + num + ' results for "' + name + '"') : ('Showing ' + num + ' results');
      }
    }

    if (wrapper && name) {
      if (!wrapper.querySelector('.ph-collection-title')) {
        var h = document.createElement('div');
        h.className = 'ph-collection-title';
        h.textContent = name;
        wrapper.insertBefore(h, wrapper.firstChild);
      }
      wrapper.classList.add('ph-collection-head');
      if (themeTitle && themeTitle.parentElement) { themeTitle.parentElement.classList.add('ph-title-source-hidden'); }
    }

    try { refreshTabs(snize); } catch (e) {}

    try {
      if (snize.querySelector('.ph-hfilters .ph-hf-pill[data-hf-value]')) { hfHideFacetBlocks(snize); }
    } catch (e) {}

    if (snize.querySelector('.ph-collection-title')) {
      document.documentElement.classList.add('ph-reorg-ready');
    }

    if (mo && snize) { mo.observe(snize, { childList: true, subtree: true }); }
  }

  var HF_TITLES = ['product type', 'category', 'subcategory'];
  function hfSlug(t) { return t.replace(/[^a-z0-9]+/g, '-'); }

  function hfUnescape(v) { return (v || '').replace(/\\(.)/g, '$1'); }

  function hfMountPoint(snize) {
    var wrapper = snize.querySelector('.snize-horizontal-wrapper');
    if (wrapper) { return { host: wrapper, before: wrapper.querySelector('.snize-horizontal-right') }; }
    var panel = snize.querySelector('.snize-main-panel');
    if (panel && panel.parentNode) { return { host: panel.parentNode, before: panel }; }
    return null;
  }

  function hfFindBar(host) {
    for (var i = 0; i < host.children.length; i++) {
      if (host.children[i].classList.contains('ph-hfilters')) { return host.children[i]; }
    }
    return null;
  }

  function hfFacets(snize) {
    var byTitle = {};
    var order = [];

    var boxes = document.querySelectorAll('.snize-product-filters-checkbox');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var title = (box.getAttribute('data-se-facet-default-title') || '')
        .replace(/\s+/g, ' ').trim().toLowerCase();

      if (!title) { title = (box.getAttribute('name') || '').trim().toLowerCase(); }
      if (!title) { continue; }
      if (!byTitle[title]) { byTitle[title] = { title: title, els: [], inputs: [] }; order.push(title); }
      byTitle[title].inputs.push(box);

      var el = box.closest ? (box.closest('.snize-product-filters-block') ||
                              box.closest('.snize-product-filters-list')) : null;
      if (el && byTitle[title].els.indexOf(el) === -1) { byTitle[title].els.push(el); }
    }

    var titles = document.querySelectorAll('.snize-product-filters-title');
    for (var t = 0; t < titles.length; t++) {
      var txt = (titles[t].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!txt) { continue; }
      for (var o = 0; o < order.length; o++) {
        var f = byTitle[order[o]];
        if (txt !== f.title && txt.indexOf(f.title) !== 0) { continue; }
        var covered = false;
        for (var e = 0; e < f.els.length; e++) {
          if (f.els[e].contains(titles[t])) { covered = true; break; }
        }
        if (!covered && f.els.indexOf(titles[t]) === -1) { f.els.push(titles[t]); }
        break;
      }
    }

    var out = [];
    for (var k = 0; k < order.length; k++) { out.push(byTitle[order[k]]); }
    return out;
  }

  function hfFilterRoot(snize) {
    var sidebar = snize.querySelector('.snize-filters-sidebar');
    if (sidebar && sidebar.querySelector('.snize-product-filters-checkbox')) { return sidebar; }
    var facets = hfFacets(snize);
    if (!facets.length) { return sidebar; }
    var first = facets[0].els[0];
    var lastEls = facets[facets.length - 1].els;
    var last = lastEls[lastEls.length - 1];
    var el = first;
    for (var up = 0; up < 8 && el && !el.contains(last); up++) { el = el.parentElement; }
    return el || first.parentElement || sidebar;
  }

  function hfFindFacet(snize, titleLc) {
    var facets = hfFacets(snize);
    for (var i = 0; i < facets.length; i++) {
      if (facets[i].title === titleLc || facets[i].title.indexOf(titleLc) === 0) { return facets[i]; }
    }
    return null;
  }

  function hfHideFacetBlocks(snize) {
    var facets = hfFacets(snize);
    for (var i = 0; i < facets.length; i++) {
      for (var h = 0; h < HF_TITLES.length; h++) {
        if (facets[i].title === HF_TITLES[h] || facets[i].title.indexOf(HF_TITLES[h]) === 0) {
          for (var e = 0; e < facets[i].els.length; e++) {
            facets[i].els[e].classList.add('ph-hf-sidebar-hidden');
          }
          break;
        }
      }
    }
  }

  function hfProxy(facet, value) {
    var inputs = facet.inputs;
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].getAttribute('value') || '') === value) { inputs[i].click(); return true; }
    }
    return false;
  }

  function hfApply(sn, slug, value, attempt) {
    var titleLc = null;
    for (var k = 0; k < HF_TITLES.length; k++) { if (hfSlug(HF_TITLES[k]) === slug) { titleLc = HF_TITLES[k]; break; } }
    var facet = titleLc ? hfFindFacet(sn, titleLc) : null;
    if (facet && hfProxy(facet, value)) { return; }
    if ((attempt || 0) < 12) {
      setTimeout(function() { hfApply(sn, slug, value, (attempt || 0) + 1); }, 120);
    }
  }

  function hfValueAvailable(sn, slug, value) {
    var titleLc = null;
    for (var k = 0; k < HF_TITLES.length; k++) { if (hfSlug(HF_TITLES[k]) === slug) { titleLc = HF_TITLES[k]; break; } }
    var facet = titleLc ? hfFindFacet(sn, titleLc) : null;
    if (!facet) { return null; }
    var inputs = facet.inputs;
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].getAttribute('value') || '') === value) { return true; }
    }
    return false;
  }

  function hfClearAll(snize) {
    var toRemove = [];
    var seen = {};
    function queue(value) {
      var k = (value || '').trim();
      if (k && !seen[k]) { seen[k] = 1; toRemove.push(value); }
    }
    var applied = window.__phApplied || {};
    for (var key in applied) {
      if (applied.hasOwnProperty(key)) { queue(key.split('\t')[1] || ''); }
    }
    var active = hfActiveSet(snize);
    var cache = window.__phTabCache || [];
    for (var c = 0; c < cache.length; c++) {
      for (var v = 0; v < cache[c].values.length; v++) {
        var val = cache[c].values[v];
        if (active[(val || '').trim()]) { queue(val); }
      }
    }
    for (var i = 0; i < toRemove.length; i++) { hfRemoveValue(snize, toRemove[i]); }
  }

  function hfRemoveValue(snize, value) {
    var vlc = (value || '').trim();
    var sidebar = hfFilterRoot(snize);
    if (!sidebar) { return false; }
    var inputs = sidebar.querySelectorAll('.snize-product-filters-checkbox:checked');
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].getAttribute('value') || '').trim() === vlc) { try { inputs[i].click(); } catch (e) {} return true; }
    }
    var els = sidebar.querySelectorAll('a, button, span, li, div');
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      if (el.closest('.snize-product-filters-list')) { continue; }
      var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!raw || raw.length > 48) { continue; }
      if (raw.replace(/\s*[×✕✖x]\s*$/i, '').trim() !== vlc) { continue; }
      var rm = null;
      var kids = el.querySelectorAll('*');
      for (var z = 0; z < kids.length; z++) {
        var kt = (kids[z].textContent || '').trim();
        if (kt === '×' || kt === '✕' || kt === '✖' || /remove|close|delete|clear/i.test(kids[z].className || '')) { rm = kids[z]; break; }
      }
      try { (rm || el).click(); } catch (e) {}
      return true;
    }
    return false;
  }

  function hfRemoveRetry(sn, value, attempt) {
    if (hfRemoveValue(sn, value)) { return; }
    if ((attempt || 0) < 12) {
      setTimeout(function() { hfRemoveRetry(sn, value, (attempt || 0) + 1); }, 120);
    }
  }

  function hfAppliedKey(slug, value) { return slug + '\t' + (value || '').trim(); }

  function hfUpdateFades(bar) {
    var max = bar.scrollWidth - bar.clientWidth;
    var x = bar.scrollLeft;
    bar.classList.toggle('ph-fade-left', x > 1);
    bar.classList.toggle('ph-fade-right', x < max - 1);
  }

  function hfAttachScroller(bar) {
    var down = false, captured = false, startX = 0, startLeft = 0, moved = false, pid = null;
    bar.addEventListener('pointerdown', function(e) {

      if (e.pointerType !== 'mouse') { return; }
      if (e.button !== 0) { return; }
      down = true; moved = false; captured = false; pid = e.pointerId;
      startX = e.clientX; startLeft = bar.scrollLeft;
    });
    bar.addEventListener('pointermove', function(e) {
      if (!down) { return; }
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        try { bar.setPointerCapture(pid); captured = true; } catch (err) {}
        bar.classList.add('is-grabbing');
      }
      if (moved) { bar.scrollLeft = startLeft - dx; }
    });
    function end() {
      if (!down) { return; }
      down = false;
      if (captured) { try { bar.releasePointerCapture(pid); } catch (err) {} captured = false; }
      bar.classList.remove('is-grabbing');
      if (moved) { bar.__phDragged = true; setTimeout(function() { bar.__phDragged = false; }, 0); }
    }
    bar.addEventListener('pointerup', end);
    bar.addEventListener('pointercancel', end);
    bar.addEventListener('scroll', function() { hfUpdateFades(bar); });

    if (!hfAttachScroller._resizeBound) {
      hfAttachScroller._resizeBound = true;
      window.addEventListener('resize', function() {
        var b = document.querySelector('#snize_results .ph-hfilters');
        if (b) { hfUpdateFades(b); }
      });
    }
  }

  function onHFPillClick(e) {
    var pill = e.target.closest ? e.target.closest('.ph-hf-pill') : null;
    if (!pill) { return; }
    e.preventDefault();

    var barEl = pill.closest ? pill.closest('.ph-hfilters') : null;
    if (barEl && barEl.__phDragged) { return; }
    var sn = document.getElementById('snize_results');
    if (!sn) { return; }
    if (pill.getAttribute('data-hf-clear-all')) { hfClearAll(sn); window.__phApplied = {}; return; }
    var value = pill.getAttribute('data-hf-value') || '';
    var slug = pill.getAttribute('data-hf');
    window.__phApplied = window.__phApplied || {};
    var avail = hfValueAvailable(sn, slug, value);

    if (pill.classList.contains('is-active')) {
      delete window.__phApplied[hfAppliedKey(slug, value)];
      hfRemoveRetry(sn, value, 0);
      return;
    }

    if (avail !== true) {
      hfClearAll(sn);
      window.__phApplied = {};
      window.__phPendingApply = { slug: slug, value: value, t: Date.now() };
      return;
    }
    window.__phApplied[hfAppliedKey(slug, value)] = 1;
    hfApply(sn, slug, value, 0);
  }

  function hfMerge(a, b) {
    var bySlug = {};
    var order = [];
    function add(groups) {
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (!g || !g.slug) { continue; }
        if (!bySlug[g.slug]) { bySlug[g.slug] = { slug: g.slug, values: [], seen: {} }; order.push(g.slug); }
        var dst = bySlug[g.slug];
        var vals = g.values || [];
        for (var j = 0; j < vals.length; j++) {
          var key = (vals[j] || '').trim();
          if (key && !dst.seen[key]) { dst.values.push(vals[j]); dst.seen[key] = 1; }
        }
      }
    }
    add(a); add(b);
    var out = [];
    for (var k = 0; k < order.length; k++) { out.push({ slug: bySlug[order[k]].slug, values: bySlug[order[k]].values }); }
    return out;
  }

  function hfCacheKey() { try { return 'phTabCache:' + location.pathname; } catch (e) { return 'phTabCache'; } }

  function hfIsFiltered(snize, groups) {
    var sidebar = hfFilterRoot(snize);
    if (!sidebar) { return false; }
    if (sidebar.querySelectorAll('.snize-product-filters-checkbox:checked').length) { return true; }
    var known = {};
    for (var g = 0; g < groups.length; g++) {
      for (var v = 0; v < groups[g].values.length; v++) { known[(groups[g].values[v] || '').trim()] = 1; }
    }
    var active = hfActiveSet(snize);
    for (var key in active) { if (active.hasOwnProperty(key) && known[key]) { return true; } }
    return false;
  }

  function hfCache(snize) {
    if (window.__phTabCache) { return window.__phTabCache; }
    var persisted = null;
    try { var s = window.localStorage && localStorage.getItem(hfCacheKey()); if (s) { persisted = JSON.parse(s); } } catch (e) {}
    var built = [];
    var haveAny = false;
    for (var i = 0; i < HF_TITLES.length; i++) {
      var facet = hfFindFacet(snize, HF_TITLES[i]);
      if (!facet) { continue; }
      haveAny = true;
      var vals = [];
      for (var j = 0; j < facet.inputs.length; j++) {
        vals.push(facet.inputs[j].getAttribute('value') || '');
      }
      if (vals.length) { built.push({ slug: hfSlug(HF_TITLES[i]), values: vals }); }
    }

    if (!haveAny && !(persisted && persisted.length)) { return null; }
    var merged = hfMerge(persisted || [], built);
    if (!merged.length) { return null; }

    if (!hfIsFiltered(snize, merged)) {

      var facetsRendered = hfFacets(snize).length > 0;
      var domBySlug = {};
      for (var b = 0; b < built.length; b++) {
        var dom = {};
        for (var dv = 0; dv < built[b].values.length; dv++) { dom[(built[b].values[dv] || '').trim()] = 1; }
        domBySlug[built[b].slug] = dom;
      }
      var pruned = [];
      for (var g2 = 0; g2 < merged.length; g2++) {
        var present = domBySlug[merged[g2].slug];
        if (!present) {
          if (!facetsRendered) { pruned.push(merged[g2]); }
          continue;
        }
        var keep = [];
        for (var k = 0; k < merged[g2].values.length; k++) {
          if (present[(merged[g2].values[k] || '').trim()]) { keep.push(merged[g2].values[k]); }
        }
        if (keep.length) { pruned.push({ slug: merged[g2].slug, values: keep }); }
      }
      merged = pruned;
    }

    if (!merged.length) {
      window.__phTabCache = null;
      try { if (window.localStorage) { localStorage.removeItem(hfCacheKey()); } } catch (e) {}
      return null;
    }

    window.__phTabCache = merged;
    try { if (window.localStorage) { localStorage.setItem(hfCacheKey(), JSON.stringify(merged)); } } catch (e) {}
    return merged;
  }

  function hfActiveSet(snize) {
    var set = {};
    var sidebar = hfFilterRoot(snize);
    if (!sidebar) { return set; }
    var checked = sidebar.querySelectorAll('.snize-product-filters-checkbox:checked');
    for (var i = 0; i < checked.length; i++) { set[(checked[i].getAttribute('value') || '').trim()] = 1; }
    var els = sidebar.querySelectorAll('a, span, li, div, button');
    for (var j = 0; j < els.length; j++) {
      if (els[j].closest('.snize-product-filters-list')) { continue; }
      var t = (els[j].textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 48) { continue; }
      set[t.replace(/\s*[×✕✖x]\s*$/i, '').trim()] = 1;
    }
    return set;
  }

  function refreshTabs(snize) {
    var mount = hfMountPoint(snize);
    if (!mount) { return; }
    var cache = hfCache(snize);
    if (!cache) {

      var stale = hfFindBar(mount.host);
      if (stale && stale.parentNode) { stale.parentNode.removeChild(stale); }
      return;
    }

    if (window.__phPendingApply) {
      var pa = window.__phPendingApply;
      if (Date.now() - pa.t > 6000) {
        window.__phPendingApply = null;
      } else if (hfValueAvailable(snize, pa.slug, pa.value) === true) {
        window.__phApplied = window.__phApplied || {};
        window.__phApplied[hfAppliedKey(pa.slug, pa.value)] = 1;
        window.__phPendingApply = null;
        hfApply(snize, pa.slug, pa.value, 0);
      }
    }

    var bar = hfFindBar(mount.host);
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'ph-hfilters';
      bar.addEventListener('click', onHFPillClick);
      hfAttachScroller(bar);
      var allBtn = document.createElement('button');
      allBtn.type = 'button';
      allBtn.className = 'ph-hf-pill ph-hf-pill--all';
      allBtn.setAttribute('data-hf-clear-all', '1');
      allBtn.textContent = 'All';
      bar.appendChild(allBtn);
      for (var g = 0; g < cache.length; g++) {
        var grp = cache[g];
        for (var v = 0; v < grp.values.length; v++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ph-hf-pill';
          b.setAttribute('data-hf', grp.slug);
          b.setAttribute('data-hf-value', grp.values[v]);
          var tspan = document.createElement('span');
          tspan.className = 'ph-hf-pill__t';
          tspan.textContent = hfUnescape(grp.values[v]);
          b.appendChild(tspan);
          bar.appendChild(b);
        }
      }

      if (mount.before) { mount.host.insertBefore(bar, mount.before); } else { mount.host.appendChild(bar); }
    }

    var vcount = {};
    for (var cg = 0; cg < cache.length; cg++) {
      for (var cv = 0; cv < cache[cg].values.length; cv++) {
        var ck = (cache[cg].values[cv] || '').trim();
        vcount[ck] = (vcount[ck] || 0) + 1;
      }
    }

    var active = hfActiveSet(snize);
    var applied = window.__phApplied || {};
    var anyActive = false;
    var pills = bar.querySelectorAll('.ph-hf-pill[data-hf-value]');
    for (var p = 0; p < pills.length; p++) {
      var pv = (pills[p].getAttribute('data-hf-value') || '').trim();
      var ps = pills[p].getAttribute('data-hf');
      var on = !!active[pv] && (!!applied[hfAppliedKey(ps, pv)] || vcount[pv] === 1);
      pills[p].classList.toggle('is-active', on);
      pills[p].setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) { anyActive = true; }

      var cspan = pills[p].querySelector('.ph-hf-pill__c');
      if (cspan) { cspan.parentNode.removeChild(cspan); }
    }
    var allPill = bar.querySelector('.ph-hf-pill--all');
    if (allPill) {
      allPill.classList.toggle('is-active', !anyActive);
      allPill.setAttribute('aria-pressed', !anyActive ? 'true' : 'false');
    }

    hfUpdateFades(bar);
  }

  function attachObserver() {

    var node = document.getElementById('snize_results');
    if (!node || !window.MutationObserver) return;
    snizeRoot = node;
    if (mo) { mo.disconnect(); }
    mo = new MutationObserver(function() {
      clearTimeout(debounce);
      debounce = setTimeout(reorg, 60);
    });
    mo.observe(node, { childList: true, subtree: true });
  }

  function setup() {
    if (!isCollectionListing()) return;

    attachObserver();
    reorg();

    var fast = true;
    var poll = setInterval(function() {
      attachObserver();
      reorg();
      if (fast && document.querySelector('#snize_results .ph-collection-title')) {
        fast = false;
        clearInterval(poll);
        poll = setInterval(function() { attachObserver(); reorg(); }, 700);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
